import App from 'app/app.js';

// Capitalizes Each Word
function CapitalizationFilter() {
  return function (text) {
    if (!!text) {
      var words = text.split(' ');
      var capitalizedWords = R.map(function (word) {
        return word.slice(0, 1).toUpperCase() + word.slice(1, word.length).toLowerCase();
      })(words);
      return capitalizedWords.join(' ');
    }
    return text;
  };
}

App.filter('CapitalizationFilter', [CapitalizationFilter]);
